import { render } from "./ctrl-chips.vue?vue&type=template&id=72ca2496&scoped=true&ts=true"
import script from "./ctrl-chips.vue?vue&type=script&lang=ts"
export * from "./ctrl-chips.vue?vue&type=script&lang=ts"

import "./ctrl-chips.vue?vue&type=style&index=0&id=72ca2496&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ca2496"]])

export default __exports__